import DataStore from './DataStore';
import Utils from '../common/Utils';
import MainCharChange from './components/MainCharChange';
import IngameOutLink from './components/IngameOutLink';

/**
 * lineage2common
 * @category lineage2common
 * @memberof module:lineage2common
 * @param  {Object} _config={} 설정 옵션
 * @param  {Object} _config.apiDomain="" api Domain
 */
class App {
    constructor(_config = {}) {
        this.store = new DataStore(_config);
        
        this.mainCharChange = new MainCharChange(this.store, '#nc-cnb .ncc-character-panel .ncc-character-list-wrap .ncc-character-list');
        this.ingameLink = new IngameOutLink(this.store);

    }
}

Utils.namespace('nc.lineage2.common');
nc.lineage2.common = App;